export const CHANGE_A1 = "CHANGE_A1";



export const ref1Change = (value) => ({
  type: CHANGE_A1,
  payload: value

});

